import * as React from "react";
import { FC, useMemo } from "react";
import { highlightText } from "~/EasyProjectsCommon/General";
import { TextProps, Text } from "../layout/Text";
import * as styles from "./highlighter.less";
import { TextHighlighter, useTextHighlighter } from "./useTextHighlighter";

type Props = TextProps & {
    text: string;
    textForHighlight: string;
    showTitle?: boolean;
};

export const Highlighter: FC<Props> = props => {
    const { textForHighlight, text, showTitle, ...textProps } = props;

    const contextHighlighter = useTextHighlighter();

    const highlightedHtml = useMemo(() => {
        let searchText = (textForHighlight ?? "").trim();
        if (!searchText) {
            return null;
        }

        const highlighter = contextHighlighter ?? getDefaultHighlighter(searchText);
        return highlighter(text, wrapperPattern);
    }, [text, contextHighlighter, textForHighlight]);

    const title = showTitle || textProps.title || textProps.truncate ? textProps.title || text : undefined;

    if (highlightedHtml) {
        return <Text {...textProps} title={title} dangerouslySetInnerHTML={{ __html: highlightedHtml }} />;
    }

    return (
        <Text {...textProps} title={title}>
            {text}
        </Text>
    );
};

const getDefaultHighlighter =
    (textForHighlight: string): TextHighlighter =>
    (text: string, wrapper: (str: string) => string) => {
        const highlight = textForHighlight.trim();
        return highlightText(text, highlight, wrapper);
    };

const wrapperPattern = (str: string) => `<mark class=${styles.match}>${str}</mark>`;
